import React from "react";
import "./ManageModuleRequests.css";
import axios from "axios";
import CacheStorage from "../../../utils/CacheStorage";
import { responseMessage } from "../../../utils/alert";
import moment from "moment";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import RefreshIcon from "@material-ui/icons/Refresh";
import SecurityIcon from "@material-ui/icons/Security";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CancelIcon from "@material-ui/icons/Cancel";
import WidgetsOutlinedIcon from "@material-ui/icons/WidgetsOutlined";
import SearchIcon from "@material-ui/icons/Search";
import DashboardHeader from "../../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../../includes/dashboardSidebar/DashboardSidebar";
import SidebarJs from "../../../common/js/sidebarAnimation";

const config = require("../../../config");

class ManageModuleRequests extends React.Component {
    constructor(props) {
        super(props);
        this.sidebarAnimation = new SidebarJs();
        this.state = {
            loading: true,
            requests: [],
            activeTab: "pending",
            processingId: null,
            searchTerm: ""
        };
    }

    componentDidMount() {
        try {
            this.sidebarAnimation.toggle();
        } catch (e) {
            // Ignore if DOM elements not ready
        }
        this.fetchRequests();
    }

    fetchRequests = () => {
        this.setState({ loading: true });
        const token = CacheStorage.getItem("userToken");

        axios.get(config.laravelBaseUrl + "admin/module-access-requests", {
            headers: {
                "Authorization": "Bearer " + (token || "")
            }
        })
        .then((res) => {
            if (res.data && res.data.status === "Success" && Array.isArray(res.data.data)) {
                this.setState({ requests: res.data.data, loading: false });
            } else {
                this.setState({ requests: [], loading: false });
            }
        })
        .catch((err) => {
            console.warn("Failed to fetch admin requests:", err);
            this.setState({ requests: [], loading: false });
        });
    };

    handleAction = (request, newStatus) => {
        this.setState({ processingId: request.RequestID });
        const token = CacheStorage.getItem("userToken");

        axios.post(config.laravelBaseUrl + "admin/grant-module-access", {
            request_id: request.RequestID,
            user_id: request.UserID,
            module_name: request.ModuleName,
            status: newStatus
        }, {
            headers: {
                "Authorization": "Bearer " + (token || "")
            }
        })
        .then((res) => {
            this.setState({ processingId: null });
            responseMessage("success", `Request ${newStatus} for user ${request.UserName} (${request.ModuleName})`, "");
            
            const updated = this.state.requests.map(item => {
                if (item.RequestID === request.RequestID) {
                    return { ...item, Status: newStatus };
                }
                return item;
            });
            this.setState({ requests: updated });
        })
        .catch((err) => {
            this.setState({ processingId: null });
            responseMessage("error", `Failed to mark request as ${newStatus}. Please try again.`, "");
        });
    };

    getInitials = (name) => {
        if (!name) return "AC";
        const parts = name.trim().split(/\s+/);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return name.slice(0, 2).toUpperCase();
    };

    render() {
        const { requests, activeTab, loading, processingId, searchTerm } = this.state;

        const pendingCount = requests.filter(r => (r.Status || "pending").toLowerCase() === "pending").length;
        const grantedCount = requests.filter(r => (r.Status || "").toLowerCase() === "granted").length;
        const totalCount = requests.length;

        const filteredRequests = requests.filter(req => {
            const matchesTab = activeTab === "all" || (req.Status || "pending").toLowerCase() === activeTab.toLowerCase();
            if (!matchesTab) return false;

            if (!searchTerm.trim()) return true;
            const term = searchTerm.toLowerCase();
            return (
                (req.CompanyName || "").toLowerCase().includes(term) ||
                (req.UserName || "").toLowerCase().includes(term) ||
                (req.UserEmail || "").toLowerCase().includes(term) ||
                (req.ModuleName || "").toLowerCase().includes(term)
            );
        });

        return [
            <DashboardHeader key="header" />,
            <div id="wrapper" key="body-wrapper">
                <DashboardSidebar />
                <div id="content-wrapper" className="d-flex flex-column" style={{ width: "100%", overflowX: "hidden" }}>
                    <div id="content">
                        <ol className="breadcrumb dashbread" style={{ margin: 0, padding: "12px 28px", background: "#ffffff", borderBottom: "1px solid #e2e8f0" }}>
                            <li className="breadcrumb-item"><a href="/admin-dashboard">Admin Dashboard</a></li>
                            <li className="breadcrumb-item active">Module Access Governance</li>
                        </ol>

                        <div className="admin-requests-container">
                            {/* Header Section */}
                            <div className="admin-requests-header">
                                <div>
                                    <span className="header-title-badge">
                                        <SecurityIcon style={{ fontSize: 13 }} /> Executive Portal
                                    </span>
                                    <h1>Client Module Access Requests</h1>
                                    <p>Review and provision AmploFly 4.0 workspace entitlements for client organizations</p>
                                </div>
                                <button className="btn-refresh-admin" onClick={this.fetchRequests}>
                                    <RefreshIcon style={{ fontSize: 18 }} /> Refresh Portal
                                </button>
                            </div>

                            {/* KPI Metrics Bar */}
                            <div className="admin-kpi-grid">
                                <div className="kpi-card pending">
                                    <div className="kpi-info">
                                        <h4>Pending Approval</h4>
                                        <div className="kpi-value">{pendingCount}</div>
                                    </div>
                                    <div className="kpi-icon-wrapper">
                                        <HourglassEmptyIcon style={{ fontSize: 26 }} />
                                    </div>
                                </div>

                                <div className="kpi-card granted">
                                    <div className="kpi-info">
                                        <h4>Granted Workspaces</h4>
                                        <div className="kpi-value">{grantedCount}</div>
                                    </div>
                                    <div className="kpi-icon-wrapper">
                                        <CheckCircleOutlineIcon style={{ fontSize: 26 }} />
                                    </div>
                                </div>

                                <div className="kpi-card total">
                                    <div className="kpi-info">
                                        <h4>Total Requests</h4>
                                        <div className="kpi-value">{totalCount}</div>
                                    </div>
                                    <div className="kpi-icon-wrapper">
                                        <WidgetsOutlinedIcon style={{ fontSize: 26 }} />
                                    </div>
                                </div>
                            </div>

                            {/* Toolbar: Filter Tabs & Search */}
                            <div className="requests-toolbar">
                                <div className="requests-filter-tabs">
                                    <button 
                                        className={`filter-tab ${activeTab === "pending" ? "active" : ""}`}
                                        onClick={() => this.setState({ activeTab: "pending" })}
                                    >
                                        Pending
                                        <span className="tab-badge">{pendingCount}</span>
                                    </button>
                                    <button 
                                        className={`filter-tab ${activeTab === "granted" ? "active" : ""}`}
                                        onClick={() => this.setState({ activeTab: "granted" })}
                                    >
                                        Granted
                                        <span className="tab-badge">{grantedCount}</span>
                                    </button>
                                    <button 
                                        className={`filter-tab ${activeTab === "rejected" ? "active" : ""}`}
                                        onClick={() => this.setState({ activeTab: "rejected" })}
                                    >
                                        Rejected
                                    </button>
                                    <button 
                                        className={`filter-tab ${activeTab === "all" ? "active" : ""}`}
                                        onClick={() => this.setState({ activeTab: "all" })}
                                    >
                                        All Requests
                                        <span className="tab-badge">{totalCount}</span>
                                    </button>
                                </div>

                                <div className="requests-search-box">
                                    <SearchIcon className="search-icon" style={{ fontSize: 18 }} />
                                    <input 
                                        type="text" 
                                        placeholder="Search organization, user or workspace..."
                                        value={searchTerm}
                                        onChange={(e) => this.setState({ searchTerm: e.target.value })}
                                    />
                                </div>
                            </div>

                            {/* Table Container */}
                            <div className="requests-table-card">
                                <table className="requests-table">
                                    <thead>
                                        <tr>
                                            <th>Client Organization</th>
                                            <th>Requester User</th>
                                            <th>Target Workspace</th>
                                            <th>Requested Date</th>
                                            <th>Governance Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="6" style={{ textAlign: "center", padding: "60px 24px" }}>
                                                    <div className="spinner-border text-primary" role="status" style={{ width: "2.2rem", height: "2.2rem" }}>
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                    <div style={{ marginTop: 12, color: "#64748b", fontWeight: 600 }}>
                                                        Loading access requests...
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : filteredRequests.length === 0 ? (
                                            <tr>
                                                <td colSpan="6">
                                                    <div className="empty-state-card">
                                                        <div className="empty-state-icon-box">
                                                            <SecurityIcon style={{ fontSize: 32 }} />
                                                        </div>
                                                        <h3>No {activeTab === "all" ? "" : activeTab} requests found</h3>
                                                        <p>There are currently no access requests matching your criteria.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredRequests.map(req => {
                                                const statusLower = (req.Status || "pending").toLowerCase();
                                                return (
                                                    <tr key={req.RequestID}>
                                                        <td className="company-cell">
                                                            <div className="company-cell-content">
                                                                <div className="company-avatar">
                                                                    {this.getInitials(req.CompanyName)}
                                                                </div>
                                                                <div className="company-details">
                                                                    <strong>{req.CompanyName || "Client Company"}</strong>
                                                                    <span>Org ID: #{req.CompanyID || "N/A"}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="user-cell">
                                                            <div className="user-cell-content">
                                                                <div className="user-avatar">
                                                                    {this.getInitials(req.UserName)}
                                                                </div>
                                                                <div className="user-details">
                                                                    <strong>{req.UserName || "User"}</strong>
                                                                    <span>{req.UserEmail || ""}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span className="module-pill-badge">
                                                                <WidgetsOutlinedIcon style={{ fontSize: 16 }} /> {req.ModuleName}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span style={{ fontWeight: 600, color: "#334155" }}>
                                                                {req.RequestedAt ? moment(req.RequestedAt).format("DD MMM YYYY") : "Recent"}
                                                            </span>
                                                            <div style={{ fontSize: 12, color: "#94a3b8" }}>
                                                                {req.RequestedAt ? moment(req.RequestedAt).format("hh:mm A") : ""}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span className={`status-pill-modern ${statusLower}`}>
                                                                <span className="status-dot"></span>
                                                                {statusLower === "pending" ? "Pending Approval" : statusLower === "granted" ? "Access Granted" : "Rejected"}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div className="action-buttons-group">
                                                                {(statusLower === "pending" || statusLower === "rejected") && (
                                                                    <button 
                                                                        className="btn-action-grant"
                                                                        disabled={processingId === req.RequestID}
                                                                        onClick={() => this.handleAction(req, "granted")}
                                                                    >
                                                                        <CheckIcon style={{ fontSize: 15 }} /> Grant Access
                                                                    </button>
                                                                )}
                                                                {(statusLower === "pending" || statusLower === "granted") && (
                                                                    <button 
                                                                        className="btn-action-reject"
                                                                        disabled={processingId === req.RequestID}
                                                                        onClick={() => this.handleAction(req, "rejected")}
                                                                    >
                                                                        <CloseIcon style={{ fontSize: 15 }} /> Reject
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ];
    }
}

export default ManageModuleRequests;
